import React, {
    Component
} from 'react'
import { call, put, takeEvery, takeLatest, select } from 'redux-saga/effects'
import { push } from 'react-router-redux';
import { actionTypes } from '../constants';
import fetch from '../utils/fetch';
import awsconfig from '../awsconfig';
import history from '../history';

const excludedFieldsForUser = [
    '_id',
    'objectType',
    'createdAt',
    'updatedAt',
    'cognitoId',
    'vcaInternalRep',
    'passwordHash',
    'absenceLogs',
    'lastInteractionAt',
];

export const Api = {
    fetchUsers: async () => {
        console.log('fetchUsers begin')
        let response = await fetch({
            url: `${awsconfig.officeApi}/users`,
            method: 'get',
        })
        let users = response.result.filter(u=>Boolean(u)); // remove null users
        return users;
    },
    fetchUser: async (id) => {
        console.log('fetchUser begin')
        let response = await fetch({
            url: `${awsconfig.officeApi}/users/${id}`,
            method: 'get',
        })
        return response.result;
    },
    updateUser: async (id, data) => {
        console.log('updateUser begin')
        // create a copy before deleting excluded keys
        const clone = JSON.parse(JSON.stringify(data));
        // remove keys that API will not accept
        Object.keys(clone).map(key => {
          if (excludedFieldsForUser.includes(key)) {
            delete clone[key];
          }
        });
        let response = await fetch({
            url: `${awsconfig.officeApi}/users/${id}`,
            data: clone,
            method: 'put',
        })
        return response.result;
    },
    createUser: async (data) => {
        console.log('createUser begin')

        // create a copy before deleting excluded keys
        const clone = JSON.parse(JSON.stringify(data));

        // remove keys that API will not accept
        Object.keys(clone).map(key => {
          if (excludedFieldsForUser.includes(key)) {
            delete clone[key]; // array is mutable so affects array in-place
          }
        });

        // POST to backend API
        let response = await fetch({
            url: `${awsconfig.officeApi}/users`,
            data: clone,
            method: 'post',
        })
        return response.result;
    },
}

function* fetchUsers(action) {
    try {
        yield put({type: actionTypes.SPINNING_START})
        const users = yield call(Api.fetchUsers);
        yield put({type: actionTypes.USERS_FETCH_ALL_SUCCESS, users: users});
        yield put({
          type: actionTypes.SNACKBAR,
          snackbar: {
            severity: 'success',
            text: `Loaded ${users.length} users from the server.`
          }
        });
    } catch (e) {
        yield put({type: actionTypes.USERS_FETCH_ALL_ERROR, error: e});
        yield put({
          type: actionTypes.SNACKBAR,
          snackbar: {
            severity: 'error',
            text: e.message
          }
        });
    } finally {
        yield put({type: actionTypes.SPINNING_STOP})
    }
}

function* fetchUser(action) {
    try {
        yield put({type: actionTypes.SPINNING_START})
        const user = yield call(Api.fetchUser, action.id);
        yield put({type: actionTypes.USERS_FETCH_ONE_SUCCESS, detail: user});
        yield put({
          type: actionTypes.SNACKBAR,
          snackbar: {
            severity: 'success',
            text: `Loaded 1 user from the server.`
          }
        });
    } catch (e) {
        yield put({type: actionTypes.USERS_FETCH_ONE_ERROR, error: e});
        yield put({
          type: actionTypes.SNACKBAR,
          snackbar: {
            severity: 'error',
            text: e.message
          }
        });
    } finally {
        yield put({type: actionTypes.SPINNING_STOP})
    }
}

function* updateUser(action) {
    try {
        yield put({type: actionTypes.SPINNING_START})
        const user = yield call(Api.updateUser, action.id, action.data);
        yield put({type: actionTypes.USERS_UPDATE_ONE_SUCCESS, detail: action.data});
        yield put({
          type: actionTypes.SNACKBAR,
          snackbar: {
            severity: 'success',
            text: `Updated 1 user.`
          }
        });
    } catch (e) {
        console.error(e)
        yield put({type: actionTypes.USERS_UPDATE_ONE_ERROR, error: e});
        yield put({
          type: actionTypes.SNACKBAR,
          snackbar: {
            severity: 'error',
            text: e.message
          }
        });
    } finally {
        yield put({type: actionTypes.SPINNING_STOP})
    }
}

function* createUser(action) {
    try {
        yield put({type: actionTypes.SPINNING_START})
        const newUser = yield call(Api.createUser, action.data); // returns array
        yield put({type: actionTypes.USERS_CREATE_ONE_SUCCESS, detail: action.data});
        yield put({
          type: actionTypes.SNACKBAR,
          snackbar: {
            severity: 'success',
            text: `Created 1 user.`
          }
        });
        // redirect to department first in case user detail page link is incorrect/errors
        history.push(`/app/departments/${action.data.clientId}`);
        if(newUser){
          history.push(`/app/departments/${action.data.clientId}/users/${newUser._id}`);
        }
    } catch (e) {
        console.error(e)
        // handle SNACKBAR differently here to show fields
        var errorMessage = e.message;
        if(e.data && e.data.messages && _.get(e.data, 'messages[0].failed', null) !== null){
            let fields = [];
            e.data.messages.map(m=>{
                let field = _.get(m, 'path[1]', null);
                let text = _.get(m, 'failed', null);
                fields.push(
                    <li><strong>{field}</strong> is {text}</li>
                )
            })
            errorMessage = (
                <React.Fragment>
                    <div>
                        The following fields are incorrect:
                        {fields}
                    </div>
                </React.Fragment>
            );
        }
        console.log('snackbar Message', errorMessage)
        yield put({type: actionTypes.USERS_CREATE_ONE_ERROR, error: e});
        yield put({
          type: actionTypes.SNACKBAR,
          snackbar: {
            severity: 'error',
            text: errorMessage
          }
        });
    } finally {
        yield put({type: actionTypes.SPINNING_STOP})
    }
}

// throttle (e.g. for autocomplete search)
// takeEvery
// takeLatest
export const sagas = {
    fetchUsersSaga: takeLatest(actionTypes.USERS_FETCH_ALL, fetchUsers),
    fetchUserSaga: takeLatest(actionTypes.USERS_FETCH_ONE, fetchUser),
    updateUserSaga: takeLatest(actionTypes.USERS_UPDATE_ONE, updateUser),
    createUserSaga: takeLatest(actionTypes.USERS_CREATE_ONE, createUser),
}
